import { useEffect, useState } from "react";
import { useSdk } from "./useSdk";
import { TokenContainer } from "@axl/membership-sdk";

export const useTokenStorage = () => {
  const [accessToken, setAccessToken] = useState<string>();
  const [refreshToken, setRefreshToken] = useState<string>();
  const sdk = useSdk();

  useEffect(() => {
    const handle = async () => {
      const res = await sdk.tokenStorage.getTokens();
      setAccessToken(res?.accessToken);
      setRefreshToken(res?.refreshToken);
    };

    handle();
    const intervalId = setInterval(handle, 1000);
    sdk.dispatcher.on("auth.token.changed", handle);

    return () => {
      sdk.dispatcher.off("auth.token.changed", handle);
      clearInterval(intervalId);
    };
  }, [sdk.dispatcher, sdk.tokenStorage]);

  return {
    accessToken,
    refreshToken,
    getTokens: async () => await sdk.tokenStorage.getTokens(),
    setTokens: async (tokens: TokenContainer | null) => await sdk.tokenStorage.setTokens(tokens, true),
  };
};
